// @ts-nocheck
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getEmailNotification, marksAsSeen } from '../../app/backlink';

// Async thunk to fetch notifications from API
export const fetchNotifications = createAsyncThunk('notifications/fetchNotifications', async () => {
  const data = await getEmailNotification();
  return data;
});

export const markNotificationAsSeen = createAsyncThunk(
  'notifications/markAsSeen',
  async (notificationId, { rejectWithValue }) => {
    try {
      const response = await marksAsSeen(notificationId);

      if (!response.success) {
        return rejectWithValue(response.message || 'Failed to mark notification as seen');
      }

      return response.notifications || [];
    } catch (error) {
      return rejectWithValue(error.message || 'Network error');
    }
  }
);

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    list: [],
    status: 'idle',
    error: null,
  },
  reducers: {
    // if you want to add local reducers here
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.list = action.payload;
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(markNotificationAsSeen.fulfilled, (state, action) => {
        state.list = action.payload;
      })
      .addCase(markNotificationAsSeen.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
      });
  },
});

export default notificationsSlice.reducer;
